// SVGのアイコンをnameに依って出し分ける

import { AccountCircle } from './icons/AccountCircle';
import { Add } from './icons/Add';
import { AddReaction } from './icons/AddReaction';
import { Address } from './icons/Address';
import { AnnounceOutline } from './icons/AnnounceOutline';
import { ArrowBackward } from './icons/ArrowBackward';
import { ArrowForward } from './icons/ArrowForward';
import { ArticleOutline } from './icons/ArticleOutline';
import { Birthdate } from './icons/Birthdate';
import { Calendar } from './icons/Calendar';
import { Check } from './icons/Check';
import { CheckCircleFilled } from './icons/CheckCircleFilled';
import { CheckCircleOutline } from './icons/CheckCircleOutline';
import { ChevronLeft } from './icons/ChevronLeft';
import { ChevronRight } from './icons/ChevronRight';
import { Clip } from './icons/Clip';
import { Close } from './icons/Close';
import { ContentCopy } from './icons/ContentCopy';
import { CorporateFare } from './icons/CorporateFare';
import { CurrencyYen } from './icons/CurrencyYen';
import { Delete } from './icons/Delete';
import { Edit } from './icons/Edit';
import { ExpandMore } from './icons/ExpandMore';
import { FileDownload } from './icons/FileDownload';
import { FilterList } from './icons/FilterList';
import { Flag } from './icons/Flag';
import { FolderFilled } from './icons/FolderFilled';
import { FolderOutline } from './icons/FolderOutline';
import { FormatListBulleted } from './icons/FormatListBulleted';
import { GridOn } from './icons/GridOn';
import { Help } from './icons/Help';
import { Home } from './icons/Home';
import { Hourglass } from './icons/Hourglass';
import { House } from './icons/House';
import { ImageIcon } from './icons/ImageIcon';
import { Info } from './icons/Info';
import { KeyBoardArrowDown } from './icons/KeyBoardArrowDown';
import { KeyBoardArrowUp } from './icons/KeyBoardArrowUp';
import { Label } from './icons/Label';
import { List } from './icons/List';
import { LocationOn } from './icons/LocationOn';
import { Logout } from './icons/Logout';
import { Mail } from './icons/Mail';
import { Menu } from './icons/Menu';
import { MoreVert } from './icons/MoreVert';
import { NotificationActive } from './icons/NotificationActive';
import { Notifications } from './icons/Notifications';
import { OpenInNew } from './icons/OpenInNew';
import { People } from './icons/People';
import { Person } from './icons/Person';
import { Phone } from './icons/Phone';
import { Poll } from './icons/Poll';
import { RemoveCircleFilled } from './icons/RemoveCircleFilled';
import { Replay } from './icons/Replay';
import { Search } from './icons/Search';
import { Send } from './icons/Send';
import { SwapVert } from './icons/SwapVert';
import { TextSMS } from './icons/TextSMS';
import { UploadFile } from './icons/UploadFile';
import { VerifiedFilled } from './icons/VerifiedFilled';
import { ViewComfy } from './icons/ViewComfy';
import { Visibility } from './icons/Visibility';
import { Warn } from './icons/Warn';
import { WavingHand } from './icons/WavingHand';

import type { FC, SVGProps } from 'react';

export const IconNames = [
  'corporate-fare',
  'people',
  'upload-file',
  'poll',
  'chevron-right',
  'chevron-left',
  'delete',
  'info',
  'close',
  'help',
  'expand-more',
  'location-on',
  'currency-yen',
  'label',
  'folder-filled',
  'birthdate',
  'address',
  'article-outline',
  'person',
  'check-circle-filled',
  'open-in-new',
  'arrow-forward',
  'house',
  'swap-vert',
  'home',
  'arrow-backward',
  'view-comfy',
  'warn',
  'remove-circle-filled',
  'visibility',
  'flag',
  'more-vert',
  'edit',
  'content-copy',
  'file-download',
  'grid-on',
  'list',
  'logout',
  'notification-active',
  'phone',
  'mail',
  'check',
  'image',
  'text-sms',
  'account-circle',
  'filter-list',
  'format-list-bulleted',
  'folder-outline',
  'check-circle-outline',
  'calendar',
  'add',
  'add-reaction',
  'notifications',
  'waving-hand',
  'verified-filled',
  'search',
  'menu',
  'announce-outline',
  'keyboard-arrow-up',
  'keyboard-arrow-down',
  'clip',
  'send',
  'hourglass',
  'replay',
] as const;

export type IconName = (typeof IconNames)[number];

export type IconSize = '12' | '14' | '16' | '18' | '20' | '24' | '28' | '30' | '32' | '40' | '44' | '48' | '56' | '64';
export interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  size?: IconSize;
}

export const Icon: FC<IconProps> = ({ name, size, width, height, className, ...rest }) => {
  const w = size ?? width ?? 16;
  const h = size ?? height ?? 16;
  const svgProps: SVGProps<SVGSVGElement> = {
    ...rest,
    width: w,
    height: h,
    className: className ?? 'fill-sem-l-icon-high',
    style: { minWidth: w, minHeight: h },
  };

  switch (name) {
    case 'corporate-fare':
      return <CorporateFare {...svgProps} />;
    case 'people':
      return <People {...svgProps} />;
    case 'upload-file':
      return <UploadFile {...svgProps} />;
    case 'poll':
      return <Poll {...svgProps} />;
    case 'chevron-right':
      return <ChevronRight {...svgProps} />;
    case 'chevron-left':
      return <ChevronLeft {...svgProps} />;
    case 'delete':
      return <Delete {...svgProps} />;
    case 'info':
      return <Info {...svgProps} />;
    case 'close':
      return <Close {...svgProps} />;
    case 'help':
      return <Help {...svgProps} />;
    case 'expand-more':
      return <ExpandMore {...svgProps} />;
    case 'location-on':
      return <LocationOn {...svgProps} />;
    case 'currency-yen':
      return <CurrencyYen {...svgProps} />;
    case 'label':
      return <Label {...svgProps} />;
    case 'folder-filled':
      return <FolderFilled {...svgProps} />;
    case 'birthdate':
      return <Birthdate {...svgProps} />;
    case 'address':
      return <Address {...svgProps} />;
    case 'article-outline':
      return <ArticleOutline {...svgProps} />;
    case 'person':
      return <Person {...svgProps} />;
    case 'check-circle-filled':
      return <CheckCircleFilled {...svgProps} />;
    case 'open-in-new':
      return <OpenInNew {...svgProps} />;
    case 'arrow-forward':
      return <ArrowForward {...svgProps} />;
    case 'house':
      return <House {...svgProps} />;
    case 'swap-vert':
      return <SwapVert {...svgProps} />;
    case 'home':
      return <Home {...svgProps} />;
    case 'arrow-backward':
      return <ArrowBackward {...svgProps} />;
    case 'view-comfy':
      return <ViewComfy {...svgProps} />;
    case 'warn':
      return <Warn {...svgProps} />;
    case 'remove-circle-filled':
      return <RemoveCircleFilled {...svgProps} />;
    case 'visibility':
      return <Visibility {...svgProps} />;
    case 'flag':
      return <Flag {...svgProps} />;
    case 'more-vert':
      return <MoreVert {...svgProps} />;
    case 'edit':
      return <Edit {...svgProps} />;
    case 'content-copy':
      return <ContentCopy {...svgProps} />;
    case 'file-download':
      return <FileDownload {...svgProps} />;
    case 'grid-on':
      return <GridOn {...svgProps} />;
    case 'list':
      return <List {...svgProps} />;
    case 'logout':
      return <Logout {...svgProps} />;
    case 'notification-active':
      return <NotificationActive {...svgProps} />;
    case 'phone':
      return <Phone {...svgProps} />;
    case 'mail':
      return <Mail {...svgProps} />;
    case 'check':
      return <Check {...svgProps} />;
    case 'image':
      return <ImageIcon {...svgProps} />;
    case 'text-sms':
      return <TextSMS {...svgProps} />;
    case 'account-circle':
      return <AccountCircle {...svgProps} />;
    case 'filter-list':
      return <FilterList {...svgProps} />;
    case 'format-list-bulleted':
      return <FormatListBulleted {...svgProps} />;
    case 'folder-outline':
      return <FolderOutline {...svgProps} />;
    case 'check-circle-outline':
      return <CheckCircleOutline {...svgProps} />;
    case 'calendar':
      return <Calendar {...svgProps} />;
    case 'add':
      return <Add {...svgProps} />;
    case 'add-reaction':
      return <AddReaction {...svgProps} />;
    case 'notifications':
      return <Notifications {...svgProps} />;
    case 'waving-hand':
      return <WavingHand {...svgProps} />;
    case 'verified-filled':
      return <VerifiedFilled {...svgProps} />;
    case 'search':
      return <Search {...svgProps} />;
    case 'menu':
      return <Menu {...svgProps} />;
    case 'announce-outline':
      return <AnnounceOutline {...svgProps} />;
    case 'keyboard-arrow-up':
      return <KeyBoardArrowUp {...svgProps} />;
    case 'keyboard-arrow-down':
      return <KeyBoardArrowDown {...svgProps} />;
    case 'clip':
      return <Clip {...svgProps} />;
    case 'send':
      return <Send {...svgProps} />;
    case 'hourglass':
      return <Hourglass {...svgProps} />;
    case 'replay':
      return <Replay {...svgProps} />;
  }
};
